import getDeliveryDetails from './getDeliveryDetails';

export const createInnervateURL = ({
  tagID, adkey, isDebug, csId, slug, campaignMetadata
}) => {
  const { store, zipcode } = getDeliveryDetails();

  const domain = 'https://rna.homedepot.com/';
  const adKeyQuery = `?adkey=${adkey}`;
  const baseURL = `${domain}${tagID}${adKeyQuery}`;

  const trx = document.cookie
    .split('; ')
    .find((row) => row.startsWith('trx='))
    ?.split('=')[1];

  const aamID = document.cookie
    .split('; ')
    .find((row) => row.startsWith('aam_uuid='))
    ?.split('=')[1];

  const obj = {};

  if (store) {
    obj.store_id = store;
  }

  if (zipcode) {
    obj.zipcode = zipcode;
  }

  if (slug) {
    obj.slug = slug;
  }

  if (csId) {
    obj.personalization_id = csId;
  }

  if (trx) {
    obj.vid = trx;
  }

  if (aamID) {
    obj.aam_id = aamID;
  }

  if (isDebug) {
    obj.debug = 'emulate';
  }

  if (campaignMetadata) {
    Object.assign(obj, JSON.parse(campaignMetadata));
  }

  const params = new URLSearchParams(obj);

  return `${baseURL}&${params}`;
};
